/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 29njzcsBEPR4koRddw4knF
// Component: V-X3eZLINq

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  PlasmicLink as PlasmicLink__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 29njzcsBEPR4koRddw4knF/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_alert_banner.css"; // plasmic-import: 29njzcsBEPR4koRddw4knF/projectcss
import sty from "./PlasmicPromoBanner.module.css"; // plasmic-import: V-X3eZLINq/css

createPlasmicElementProxy;

export type PlasmicPromoBanner__VariantMembers = {};
export type PlasmicPromoBanner__VariantsArgs = {};
type VariantPropType = keyof PlasmicPromoBanner__VariantsArgs;
export const PlasmicPromoBanner__VariantProps = new Array<VariantPropType>();

export type PlasmicPromoBanner__ArgsType = {
  message?: string;
  bannerUrl?: string;
};
type ArgPropType = keyof PlasmicPromoBanner__ArgsType;
export const PlasmicPromoBanner__ArgProps = new Array<ArgPropType>(
  "message",
  "bannerUrl"
);

export type PlasmicPromoBanner__OverridesType = {
  root?: Flex__<"a">;
  text?: Flex__<"div">;
};

export interface DefaultPromoBannerProps {
  message?: string;
  bannerUrl?: string;
  className?: string;
}

const $$ = {};

function PlasmicPromoBanner__RenderFunc(props: {
  variants: PlasmicPromoBanner__VariantsArgs;
  args: PlasmicPromoBanner__ArgsType;
  overrides: PlasmicPromoBanner__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          message: "Sign up!",
          bannerUrl: "https://studio.plasmic.app/signup",
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <PlasmicLink__
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "a",
        "a__29njz",
        "root_reset_29njzcsBEPR4koRddw4knF",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      href={args.bannerUrl}
      platform={"react"}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames("all", "__wab_text", sty.text)}
      >
        <React.Fragment>
          {(() => {
            try {
              return $props.message;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </div>
    </PlasmicLink__>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "text"],
  text: ["text"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "a";
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPromoBanner__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPromoBanner__VariantsArgs;
    args?: PlasmicPromoBanner__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicPromoBanner__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPromoBanner__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPromoBanner__ArgProps,
          internalVariantPropNames: PlasmicPromoBanner__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPromoBanner__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPromoBanner";
  } else {
    func.displayName = `PlasmicPromoBanner.${nodeName}`;
  }
  return func;
}

export const PlasmicPromoBanner = Object.assign(
  // Top-level PlasmicPromoBanner renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicPromoBanner
    internalVariantProps: PlasmicPromoBanner__VariantProps,
    internalArgProps: PlasmicPromoBanner__ArgProps,
  }
);

export default PlasmicPromoBanner;
/* prettier-ignore-end */
